module.exports = __webpack_public_path__ + "static/media/turnos-online_new.37e5a9c3.jpg";